var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:_vm.classes},[_c('AppHeader',{attrs:{"user":_vm.$store.state.user,"hasSidebar":""},on:{"mobileMenuToggle":function($event){_vm.showMobileMenu = !_vm.showMobileMenu}}}),_c('div',{staticClass:"app-body"},[(_vm.user.id)?_c('AppSidebar'):_vm._e(),_c('main',{staticClass:"main"},[(_vm.user.id)?_c('SubHeader',{attrs:{"user":_vm.user}}):_vm._e(),_c('div',{staticClass:"flex-grow-1",class:{
          container: _vm.$route.meta.container !== false,
          'py-5': !_vm.user.id
        }},[_c('RouterView')],1)],1)],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }